import { clearAllCorporateActiveFacilityKeys } from "./corporateFacilityStorage";

const AUTH_OWNER_KEY = "prntyr:authOwner";

// Only include keys that can cause cross-user leakage
const CRITICAL_KEYS = [
  "newsletter_Speak2ContentParams",
  "calendar_Speak2ContentParams",
  "slides_Speak2ContentParams",
  // add more user-scoped keys here as needed
];

export function clearCriticalLocalKeys() {
  if (typeof window === "undefined") return;
  for (const k of CRITICAL_KEYS) {
    localStorage.removeItem(k);
  }
}

/**
 * Ensures localStorage user-scoped keys belong to the current user.
 * If last owner differs -> clear critical keys.
 *
 * realm: "speak2" | "prntyr"
 */
export function reconcileStorageOwner({ userId, realm }) {
  if (typeof window === "undefined") return;

  if (!userId) return; // nothing to reconcile without a confirmed identity
  const safeRealm = realm || "unknown";

  const currentOwner = `${safeRealm}:${userId}`;
  const prevOwner = localStorage.getItem(AUTH_OWNER_KEY);

  // Clear in BOTH cases:
  // 1) first login on this browser (prevOwner is null)
  // 2) user changed (prevOwner exists but different)
  if (prevOwner !== currentOwner) {
    clearCriticalLocalKeys();
    clearAllCorporateActiveFacilityKeys();
  }

  // Always set/update owner for future comparisons
  localStorage.setItem(AUTH_OWNER_KEY, currentOwner);
}
